import React from 'react'

const Puse = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_281_99)">
<mask height="26" id="mask0_281_99" maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }} width="26" x="0" y="0">
<path d="M0 0H26V26H0V0Z" fill="currentColor"></path>
</mask>
<g mask="url(#mask0_281_99)">
<path d="M21.3731 11.8399C21.9183 13.8706 21.7066 16.0303 20.7775 17.9165C19.8485 19.8028 18.2654 21.2869 16.3232 22.0925C14.381 22.898 12.2122 22.9701 10.2208 22.2951C8.22947 21.6202 6.5514 20.2443 5.49925 18.4239C4.4471 16.6034 4.09264 14.4626 4.5019 12.4002C4.91117 10.3378 6.05625 8.49446 7.7238 7.21372C9.39135 5.93298 11.4676 5.30213 13.5658 5.43873C15.664 5.57532 17.641 6.47004 19.1284 7.95617L19.8943 8.721" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.625"></path>
<path d="M15.2977 8.72099H19.8943V4.12549" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.625"></path>
</g>
</g>
<defs>
<clipPath id="clip0_281_99">
<rect fill="currentColor" height="26" width="26"></rect>
</clipPath>
</defs>
</svg>
    )
}

export default Puse
